import { render } from "./ModalChat.vue?vue&type=template&id=1b8664f2&scoped=true"
import script from "./ModalChat.vue?vue&type=script&lang=js"
export * from "./ModalChat.vue?vue&type=script&lang=js"

import "./ModalChat.vue?vue&type=style&index=0&id=1b8664f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8664f2"]])

export default __exports__